/**
 * Fake graphql tag to enable code generation.
 *
 * @deprecated No new GraphQL queries: Strapi is read through REST, see `@lib/strapi/rest/client`.
 */
const graphql = (strings: TemplateStringsArray, ...keys: string[]) =>
  strings.map((text, i) => (i > 0 ? keys[i - 1] : "") + text).join("");
export default graphql;
